import { render } from "./HazDiscussCaseList.vue?vue&type=template&id=5c6f3d6f"
import script from "./HazDiscussCaseList.vue?vue&type=script&lang=js"
export * from "./HazDiscussCaseList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__